<input [disabled]="review" type="number" [(ngModel)]="answer" placeholder="Answer" class="input" (input)="onChange(answer)"/>
